import numeral from 'numeral';

export const formatNumber = (num: number) => {
  return numeral(num).format('0,0');
};

export const formatNumberKeepDecimal = (num: number) => {
  num = num < 0 ? 0 : num;
  return numeral(num).format('0,0.00');
};

export const parseStringToNumber = (stringNum: string) => {
  return parseFloat(stringNum.replaceAll(',', ''));
};

export const textToNumber = (input = '') => {
  /**
   *  takes in formatted numbers, and parse it into float
   */

  try {
    input = input.replace(/,/g, '');
    const floatVal = parseFloat(input);
    return isNaN(floatVal) ? 0 : floatVal;
  } catch (e) {
    return 0;
  }
};
